import { render, staticRenderFns } from "./IconSWW.vue?vue&type=template&id=7a6c6b01"
import script from "./IconSWW.vue?vue&type=script&lang=ts"
export * from "./IconSWW.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports